/**
 * Shared TanStack Query client.
 *
 * Defaults are tuned for internal apps that change infrequently:
 *   - staleTime 1 min so navigating between pages doesn't refetch constantly
 *   - no auto-refetch on window focus (more startling than helpful)
 *   - no retries on 401/403 — let ProtectedRoute redirect instead
 */

import { QueryClient } from "@tanstack/react-query";

import { isAuthError } from "./client";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (isAuthError(error)) {
          return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
